/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAviDataGridState } from './avi-data-grid-store.state';

export const featureKey = 'aviDataGridStore';

const selectFeature = createFeatureSelector<IAviDataGridState>(
    featureKey,
);

export const selectAviDataGridState = createSelector(
    selectFeature,
    (aviDataGridState: IAviDataGridState) => aviDataGridState,
);
